import React, { useEffect } from "react";
import "./Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      // Instantly scroll to top (you can use smooth if needed)
      // window.scrollTo(0, 0);

      // Lock scroll - mobile safe
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'relative';
      // document.body.style.width = '100%';
      // document.body.style.top = '0';
    } else {
      // Unlock scroll
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    }

    // Always cleanup on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="custom-modal-overlay"
      // onClick={onClose} 
    >
      <div
        className="custom-modal-container"
        onClick={(e) => e.stopPropagation()} // prevent closing on content click
      >
        <button className="custom-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
